import { ApiError } from './ApiError';

// Superclass for errors involving API calls with extra, significant
// information in the body. Can include stuff as "Duplicate Records"
// error messages
export class ApiBodyError extends ApiError {
  static errorName = 'ApiBodyError';

  public body: unknown; // Expect to be a JSON object.

  constructor(message: string, body: unknown) {
    super(message);
    this.body = body;
  }
}

export type DefinedError = { body: { errors: { message: string; name: string }[] } };

export function isDefinedError(element: unknown): element is DefinedError {
  return Array.isArray((element as DefinedError).body.errors);
}
